import { FC } from 'react';

// styles
import styles from './PdpRespPersonalizedItemsCarouselLoading.scss';

export const PdpRespPersonalizedItemsCarouselLoading: FC = () => (
    <div className={styles.container}>
        <span className={styles.title} />
        <div className={styles.tileContainer}>
            <div className={styles.tile} />
            <div className={styles.tile} />
            <div className={styles.tile} />
            <div className={styles.tile} />
            <div className={styles.tile} />
        </div>
    </div>
);
